import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import BlogPage from "@/pages/BlogPage";
import CategoryPage from "@/pages/CategoryPage";
import AuthorPage from "@/pages/AuthorPage";
import SearchPage from "@/pages/SearchPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import RubriquePage from "@/pages/RubriquePage";
import MediathequePage from "@/pages/MediathequePage";
import NewsletterArchivePage from "@/pages/NewsletterArchivePage";
import LaToilePage from "@/pages/LaToilePage";
import BookmarksPage from "@/pages/BookmarksPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "@/pages/PolitiqueConfidentialitePage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import ArticleList from "@/pages/admin/ArticleList";
import CategoryManager from "@/pages/admin/CategoryManager";
import AuthorManager from "@/pages/admin/AuthorManager";
import TagManager from "@/pages/admin/TagManager";
import NewsletterManager from "@/pages/admin/NewsletterManager";
import EditorialCalendar from "@/pages/admin/EditorialCalendar";
import ContactManager from "@/pages/admin/ContactManager";
import ProfilePage from "@/pages/admin/ProfilePage";
import RubriqueManager from "@/pages/admin/RubriqueManager";
import MediathequeAdmin from "@/pages/admin/MediathequeAdmin";

function GA4RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    // Wait for Helmet to update <title> before sending to GA4
    setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'page_view', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: location.pathname + location.search,
        });
      }
    }, 100);
  }, [location]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <GA4RouteTracker />
          <Toaster position="top-right" />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/article/:slug" element={<ArticlePage />} />
              <Route path="/categorie/:slug" element={<CategoryPage />} />
              <Route path="/rubrique/:slug" element={<RubriquePage />} />
              <Route path="/mediatheque" element={<MediathequePage />} />
              <Route path="/newsletter" element={<NewsletterArchivePage />} />
              <Route path="/la-toile" element={<LaToilePage />} />
              <Route path="/signets" element={<BookmarksPage />} />
              <Route path="/auteur/:slug" element={<AuthorPage />} />
              <Route path="/recherche" element={<SearchPage />} />
              <Route path="/a-propos" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="articles" element={<ArticleList />} />
              <Route path="articles/new" element={<ArticleEditor />} />
              <Route path="articles/:id/edit" element={<ArticleEditor />} />
              <Route path="categories" element={<CategoryManager />} />
              <Route path="auteurs" element={<AuthorManager />} />
              <Route path="tags" element={<TagManager />} />
              <Route path="newsletter" element={<NewsletterManager />} />
              <Route path="calendrier" element={<EditorialCalendar />} />
              <Route path="messages" element={<ContactManager />} />
              <Route path="rubriques" element={<RubriqueManager />} />
              <Route path="mediatheque" element={<MediathequeAdmin />} />
              <Route path="profil" element={<ProfilePage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
